import aiAssistant from './aiAssistant';

export default aiAssistant;
